<div class="flex-auto flex items-center justify-center">
  <div class="flex flex-col items-center justify-center">
    <div class="text-4xl font-bold">Access denied!</div>
    <button mat-raised-button color="primary" (click)="signOut()">
      <mat-icon svgIcon="heroicons_outline:logout"></mat-icon><span class="ml-2">Sign Out</span>
    </button>
  </div>
</div>
